// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tooltip_wrapper__6rRbD","tooltip":"Tooltip_tooltip__2vali","fadeIn":"Tooltip_fadeIn__15Ynl"};